/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Street/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Street({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/Edit/Content/Details/Office/Street",
  isInvalid,
  onChange,
  onChooseAddress
  
}) {
let editProfessionalEmployeeProviderEmployeeResourceEmploymentContractOrganizationPostalAddressAddressLine1ValueData = fromData.useDataValue({ viewPath,
context: 'edit_professional',
path: 'employee.provider.employee_resource.employment_contract.organization.postal_address.address_line1',
})
let editProfessionalEmployeeProviderEmployeeResourceEmploymentContractOrganizationPostalAddressAddressLine1IsValidData = fromData.useDataIsValid({ viewPath,
context: 'edit_professional',
path: 'employee.provider.employee_resource.employment_contract.organization.postal_address.address_line1',
validate: fromValidate.street,
required: true,
})
let editProfessionalEmployeeProviderEmployeeResourceEmploymentContractOrganizationPostalAddressAddressLine1ChangeData = fromData.useDataChange({ viewPath,
context: 'edit_professional',
path: 'employee.provider.employee_resource.employment_contract.organization.postal_address.address_line1',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 disabled={true}
 data="edit_professional.employee.provider.employee_resource.employment_contract.organization.postal_address.address_line1"
 validate="/Data/validate.js street"
 required={true}
 invalid={!editProfessionalEmployeeProviderEmployeeResourceEmploymentContractOrganizationPostalAddressAddressLine1IsValidData}
 value={editProfessionalEmployeeProviderEmployeeResourceEmploymentContractOrganizationPostalAddressAddressLine1ValueData}
 onChange={editProfessionalEmployeeProviderEmployeeResourceEmploymentContractOrganizationPostalAddressAddressLine1ChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Street"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 focusOnDownArrowKey={true}
 onChooseAddress={onChooseAddress}
 type="address"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}